import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';
import DetailsSectionContacts from 'app/main/modules/components/DetailsSectionContacts';

import CompaniesEvents from './CompaniesEvents';

import CompaniesDetailsSectionInfo from './details/sections/CompaniesDetailsSectionInfo';
import CompaniesDetailsSectionAddress from './details/sections/CompaniesDetailsSectionAddress';
import CompaniesDetailsSectionSecondaryInfo from './details/sections/CompaniesDetailsSectionSecondaryInfo';
import CompaniesDetailsSectionSource from './details/sections/CompaniesDetailsSectionSource';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<CompaniesDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="comp_descriptionhtml"
				value={props.model.comp_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
			<InlineTitle text="DETAILS_ADDRESS_SECTION" />
			<CompaniesDetailsSectionAddress {...props} />
			<InlineTitle text="DETAILS_SECONDARY_INFO_SECTION" />
			<CompaniesDetailsSectionSecondaryInfo {...props} />
			{props.isAdd && (
				<>
					<InlineTitle text="DETAILS_CONTACTS_MAILS_SECTION" />
					<DetailsSectionContacts
						module="mails"
						listField="comp_mails"
						list={props.model.comp_mails}
						sendChange={props.sendChange}
					/>
					<InlineTitle text="DETAILS_CONTACTS_PHONES_SECTION" />
					<DetailsSectionContacts
						module="phones"
						listField="comp_phones"
						list={props.model.comp_phones}
						sendChange={props.sendChange}
					/>
				</>
			)}
			<InlineTitle text="DETAILS_SOURCE_SECTION" />
			<CompaniesDetailsSectionSource {...props} />
		</>
	),
	events: CompaniesEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
